import { TAB_CONTENT_PT_BR } from "../components/tab-content/translations";
import { TABLE_EXTRACT_PT_BR } from "../components/table-extract/translations";
import { WALLET_INDICATOR_PT_BR } from "../components/wallet-indicator/translations";
import { FUTURE_ENTRIES_INDICATOR_PT_BR } from "../components/future-entries-indicator/translations";
import { FUTURE_ENTRIES_MODAL_PT_BR } from "../components/future-entries-modal/translations";
import { WALLET_DRAWER_PT_BR } from "../components/wallet-drawer/translations";
import { SAVED_ACCOUNTS_MODAL_PT_BR } from "../components/saved-accounts-modal/translations";
import { LATEST_TRANSACTIONS_TABLE_PT_BR } from "../components/latest-transactions-table/translations";
import { FLOW_EXTRACT_PT_BR } from "../pages/flow/translations";
import { BLOCKED_VALUE_MODAL_PT_BR } from "../components/blocked-value-modal/translations";

export const EXTRACT_PT_BR = {
	title: "Conta de Pagamento",
	graphics: "Gráfica",
	subtitle: `Acompanhe suas movimentações financeiras com clareza e entenda suas transações, 
		faturas e saques de forma prática.`,
	oldExtract: "Extrato Legado",
	oldExtractExpireAt: "Até 05/08/2025",
	walletIndicator: WALLET_INDICATOR_PT_BR,
	futureEntriesIndicator: FUTURE_ENTRIES_INDICATOR_PT_BR,
	tab: TAB_CONTENT_PT_BR,
	tableExtract: TABLE_EXTRACT_PT_BR,
	futureEntriesModal: FUTURE_ENTRIES_MODAL_PT_BR,
	walletDrawer: WALLET_DRAWER_PT_BR,
	savedAccountsModal: SAVED_ACCOUNTS_MODAL_PT_BR,
	latestTransactions: LATEST_TRANSACTIONS_TABLE_PT_BR,
	flow: FLOW_EXTRACT_PT_BR,
	blockedValueModal: BLOCKED_VALUE_MODAL_PT_BR,
	filterBy: "Filtrar por",
	typeFilter: "Digite um filtro",
	groupBy: "Agrupar por",
	groupedBy: "Agrupado",
	drawer: {
		withdraw: "Saque",
		anticipation: "Antecipação",
		ticketPayment: "Pagamento de Boletos",
		transferBetweenPlaces: "Transferencia entre Places",
	},
	search: {
		emptyState: "Nenhum filtro encontrado",
		clearAllTooltip: "Limpar todos os filtros",
	},
};

export type ExtractTranslations = typeof EXTRACT_PT_BR;
